import axios from "../../axiosInstance";

const baseUrlApiOPBill = '/ob/billing'
class AcountsServices {

    getAccountLedgerType(){
        return axios.get(baseUrlApiOPBill+'/getAccountLedgerType');
    }
    getAccountHead(){
        return axios.get(baseUrlApiOPBill+'/getAccountHead');
    }
    insertAccountHead(details){
        return axios.post(baseUrlApiOPBill+'/insertAccountHead',details);
    }
    updateAccountHead(details){
        return axios.put(baseUrlApiOPBill+'/updateAccountHead',details);
    }
    deleteAccountHead(headName){
        return axios.delete(baseUrlApiOPBill+'/deleteAccountHead?headName='+headName);
    }

    //billpaidByy

    getBillPaidBy(){
        return axios.get(baseUrlApiOPBill+'/getBillPaidBy')
    }
    insertBillPaidBy(details){
        return axios.post(baseUrlApiOPBill+'/insertBillPaidBy',details);
    }
    updateBillPaidBy(details){
        return axios.put(baseUrlApiOPBill+'/updateBillPaidBy',details);
    }
    deleteBillPaidBy(billPaidBy){
        return axios.delete(baseUrlApiOPBill+'/deleteBillPaidBy?billPaidBy='+billPaidBy);
    }
  
    //billPaidTo
    getBillPaidTo(){
        return axios.get(baseUrlApiOPBill+'/getBillPaidTo')
    }

    insertBillPaidTo(details){
        return axios.post(baseUrlApiOPBill+'/insertBillPaidTo',details);
    }
    updateBillPaidTo(details){
        return axios.put(baseUrlApiOPBill+'/updateBillPaidTo',details);
    }
    deleteBillPaidTo(billPaidTo){
        return axios.delete(baseUrlApiOPBill+'/deleteBillPaidTo?billPaidTo='+billPaidTo);
    }

    //paymentType
    getBillPaymentType(){
        return axios.get(baseUrlApiOPBill+'/getBillPaymentType')
    }
    insertPaymentType(details){
        return axios.post(baseUrlApiOPBill+'/insertPaymentType',details);
    }
    updatePaymentType(details){
        return axios.put(baseUrlApiOPBill+'/updatePaymentType',details);
    }
    deletePaymentType(paymentType){
        return axios.delete(baseUrlApiOPBill+'/deletePaymentType?paymentType='+paymentType);
    }

    //PrintedType
    getPrintedType(){
        return axios.get(baseUrlApiOPBill+'/getPrintedType');
    }

    insertPrintedType(details){
        return axios.post(baseUrlApiOPBill+'/insertPrintedType',details);
    }
    updatePrintedType(details){
        return axios.put(baseUrlApiOPBill+'/updatePrintedType',details);
    }
    deletePrintedType(printedType){
        return axios.delete(baseUrlApiOPBill+'/deletePrintedType?printedType='+printedType);
    }
    //vocherTyype
    getVoucherType(){
        return axios.get(baseUrlApiOPBill+'/getVoucherType');
    }
    insertVoucherType(details){
        return axios.post(baseUrlApiOPBill+'/insertVoucherType',details);
    }
    updateVoucherType(details){
        return axios.put(baseUrlApiOPBill+'/updateVoucherType',details);
    }
    deleteVoucherType(voucherType){
        return axios.delete(baseUrlApiOPBill+'/deleteVoucherType?voucherType='+voucherType);
    }

}
export default new AcountsServices();